<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading">Purchases</span> -->
          <v-spacer></v-spacer>
          <v-flex xl3 lg3 md3 pb-2 sm3 xs12 px-5>
            <v-btn
              style="font-family: kumbhBold"
              dark
              block
              class="rounded-xl"
              color="#005f32"
              to="/Assets/AddPurchase"
            >
              <span style="color: #ffffff"> Add Stock </span>
            </v-btn>
          </v-flex>
          <v-flex xs12 align-self-center py-2>
            <v-layout wrap justify-end>
              <v-flex xl3 lg3 md3 pb-2 sm3 xs12 px-2>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      outlined
                      class="rounded-xl"
                      hide-details
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    no-title
                    @input="menu11 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xl3 lg3 md3 pb-2 sm3 xs12 px-2>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      outlined
                      hide-details
                      dense
                      class="rounded-xl"
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start v-if="purchaseList.length > 0">
          <v-flex xs12>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Purchase Id</th>
                    <th class="text-left">Discount(INR)</th>
                    <th class="text-left">Discount Price(INR)</th>
                    <th class="text-left">Total Price(INR)</th>
                    <th class="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <tr
                    class="text-left align-center"
                    v-for="(item, i) in purchaseList"
                    :key="i"
                  >
                    <td>
                      <span
                        v-if="item.create_date"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.create_date.slice(0, 10) }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.purchaseId"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.purchaseId }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.discount"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.discount }}</span
                      >
                    </td>

                    <td>
                      <span
                        v-if="item.billAmount"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.billAmount }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.totalAmount"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.totalAmount }}</span
                      >
                    </td>
                    <td>
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left pa-2>
                          <v-dialog v-model="item.view" max-width="70%">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                title="View"
                                color="#005f32"
                                v-on="on"
                                v-bind="attrs"
                                >mdi-eye</v-icon
                              >
                            </template>
                            <v-card>
                              <v-layout wrap>
                                <v-flex
                                  xs12
                                  align-self-center
                                  pa-4
                                  style="background: #005f32"
                                  text-left
                                >
                                  <span class="kumbhBold" style="color: #ffffff"
                                    >Purchase Details</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  align-self-center
                                  class="kumbhRegular"
                                >
                                  <v-layout wrap pa-4>
                                    <v-flex
                                      xs12
                                      sm6
                                      align-self-center
                                      text-left
                                      pa-1
                                    >
                                      <span v-if="item.purchaseId">
                                        Purchase ID : {{ item.purchaseId }}
                                      </span>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      sm6
                                      align-self-center
                                      text-left
                                      pa-1
                                    >
                                      <span v-if="item.discount">
                                        Discount(INR) : {{ item.discount }}
                                      </span>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      sm6
                                      align-self-center
                                      text-left
                                      pa-1
                                    >
                                      <span v-if="item.billAmount">
                                        Discount Price(INR) :
                                        {{ item.billAmount }}
                                      </span>
                                    </v-flex>

                                    <v-flex
                                      xs12
                                      sm6
                                      align-self-center
                                      text-left
                                      pa-1
                                    >
                                      <span v-if="item.totalAmount">
                                        Total Price(INR) :
                                        {{ item.totalAmount }}
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 pa-2>
                                      <v-divider></v-divider>
                                    </v-flex>

                                    <v-flex
                                      xs12 
                                      align-self-center
                                      text-left
                                      pa-4
                                    >
                                      <span class="kumbhMedium" v-if="item.bill">
                                        Bill &nbsp;&nbsp;&nbsp;
                                        <a target="_blank" :href="mediaURL + item.bill" download="Download Bill">
                                          <v-btn  color="#005f32" small dark tile>
                                          View Bill
                                        </v-btn>
                                        </a>
                                      </span>
                                      <span v-else>
                                        No bill uploaded!
                                      </span>
                                    </v-flex>

                                    
                                    <v-flex xs12 pa-2>
                                      <v-divider></v-divider>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      align-self-center
                                      text-left
                                      pa-4
                                    >
                                      <span class="kumbhBold"> Item(s) </span>
                                    </v-flex>

                                    <v-flex xs12 align-self-center>
                                      <v-layout wrap>
                                        <v-flex
                                          xs12
                                          sm6
                                          pa-1
                                          v-for="(split, s) in item.purchase"
                                          :key="s"
                                        >
                                          <v-card
                                            outlined
                                            class="rounded-lg pa-3 kumbhMedium"
                                          >
                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.name"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span> Asset name </span>
                                              </v-flex>
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  {{ split.name }}
                                                </span>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.catVal"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span> Asset category </span>
                                              </v-flex>
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  {{ split.catVal }}
                                                </span>
                                              </v-flex>
                                            </v-layout>

                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.assetType"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span> Asset type </span>
                                              </v-flex>
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  {{ split.assetType }}
                                                </span>
                                              </v-flex>
                                            </v-layout>

                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.description"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span> Description </span>
                                              </v-flex>
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  {{ split.description }}
                                                </span>
                                              </v-flex>
                                            </v-layout>

                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.assetId"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span> Asset </span>
                                              </v-flex>
                                              <v-flex
                                                xs6
                                                align-self-center
                                                v-if="split.assetId.name"
                                              >
                                                <span>
                                                  {{ split.assetId.name }}
                                                </span>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.purchaseAmount"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  Purchase Amount(INR)
                                                </span>
                                              </v-flex>
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  {{ split.purchaseAmount }}
                                                </span>
                                              </v-flex>
                                            </v-layout>
                                            <v-layout
                                              wrap
                                              pa-2
                                              text-left
                                              v-if="split.quantity"
                                            >
                                              <v-flex xs6 align-self-center>
                                                <span> Quantity </span>
                                              </v-flex>
                                              <v-flex xs6 align-self-center>
                                                <span>
                                                  {{ split.quantity }}
                                                </span>
                                              </v-flex>
                                            </v-layout>
                                          </v-card>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>

                              <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="error"
                                  tile
                                  dark
                                  @click="item.view = false"
                                  >Cancel</v-btn
                                >
                                &nbsp;
                              </v-card-actions> -->
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Purchases found!</span>
          </v-flex>
        </v-layout>

        <v-dialog persistent v-model="editdialog" max-width="40%">
          <v-card tile>
            <v-layout wrap>
              <v-flex
                xs12
                pa-4
                text-left
                align-self-center
                style="background: #005f32 !important"
              >
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px"
                  >Edit Category</span
                >
              </v-flex>
              <v-flex xs12 pa-5 pt-8 text-left>
                <v-text-field
                  v-model="editingitem.name"
                  label="Category Name"
                  :rules="[rules.required]"
                  outlined
                  autofocus
                  dense
                  required
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                tile
                outlined
                @click="(editdialog = false), getData()"
              >
                Close
              </v-btn>
              &nbsp;
              <v-btn
                v-if="!g"
                color="#005f32"
                dark
                tile
                @click="edit(editingitem._id)"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#005f32"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: [],
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      g: false,
      totalData: 0,
      addcat: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      purchaseList: [],
      data: [],
      coverImageFile: null,
      selectedFiles: [],
      image: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      name: null,
      assetId: null,
      date: new Date(),
      fromDate: new Date(),
      toDate: new Date(),
      menu1: false,
      menu2: false,
    };
  },
  mounted() {
    if (this.fromDate) {
      this.fromDate=null
      // this.fromDate.setDate(this.fromDate.getDate() - 31);
      // this.fromDate = this.fromDate.toISOString().substr(0, 10);
    }
    if (this.toDate) {
      this.toDate = null;
      // this.toDate.setDate(this.toDate.getDate());
      // this.toDate = this.toDate.toISOString().substr(0, 10);
    }
    this.getData();
  },
  watch: {
    fromDate() {
       this.currentPage = 1;

      this.getData();
    },
    toDate() {
       this.currentPage = 1;
      this.getData();
    },
    
    currentPage() {
      this.getData()
    }
  },

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/asset/inventoryPurchases/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          page: this.currentPage,
          limit: 20,
          from: this.fromDate,
          to: this.toDate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.purchaseList = response.data.data;
          this.totalData = response.data.totalLength;
          this.pages = Math.ceil(this.totalData / response.data.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
